import { Event } from '@gamenight/common/dist/types';

import { getAttendees } from './get-attendees';

// Returns array of emails of guests and users
export const getAttendanceEmails = (event: Event): string[] =>
  getAttendees(event)
    .filter(item => item.guest_email || item.user?.email)
    .map(item => `${item.guest_email ? item.guest_email : item.user?.email}`);
